module.exports = __webpack_public_path__ + "static/media/Power_Led_2.dd4d3747.png";